export enum UserRoleEnum {
    USER = 'USER',
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    EXTERNAL_USER = 'EXTERNAL_USER',
}

/** TODO: Add more fields when further scoped out */
export type User = {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    createdAt: Date;
    updatedAt: Date;
    role?: UserRoleEnum;
    profileHexColour: string;
    avatarUrl?: string | null;
    auth0Id: string;
    assignedWorkpapers: string[] | null;
    xero?: {
        xeroRefer: boolean;
        xeroUserId?: string;
    };
};

export type UserOverview = {
    id: string;
    firstName: string;
    lastName: string;
    profileHexColour: string;
    avatarUrl?: string | null;
    email?: string;
};

export type UserFirmRole = {
    firmId: string;
    userId: string;
    role: UserRoleEnum;
    createdAt: Date;
    updatedAt: Date;
};

export type UserTemplateCsv = {
    'Email *': string;
    'Role *': string;
};
